"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionsMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
const _1 = require(".");
class TransactionsMapper {
    toDomain(result) {
        const transactionMapper = new _1.TransactionMapper();
        const pageInfo = lodash_1.default.get(result, "data.getUser.guests.edges[0].node.transactions.pageInfo");
        const isLoading = lodash_1.default.get(result, "loading");
        const rawTransactions = lodash_1.default.get(result, "data.getUser.guests.edges[0].node.transactions.edges");
        const transactions = rawTransactions.map((_trans) => transactionMapper.toDomain(_trans));
        return {
            isLoading,
            pageInfo,
            transactions,
        };
    }
}
exports.TransactionsMapper = TransactionsMapper;
